import { render, staticRenderFns } from "./PickupOrder.vue?vue&type=template&id=244998b7&"
import script from "./PickupOrder.vue?vue&type=script&lang=js&"
export * from "./PickupOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports